import styled from '@emotion/styled';
import { Grid, lighten, darken, useTheme } from "@mui/material";

import { BasicFlex } from '../../../utils/Common';

import { useQuery } from '@tanstack/react-query';

import { getPaymentStats } from '../apiService';

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';

import useTableStore from '../../../store/table';

import { formatCurrency } from '../../../utils/util';

import { getSettingByResource } from '../../Settings/apiService';

const Container = styled(BasicFlex)`
  margin-bottom: 1.5rem;
`

const Card = styled(BasicFlex)`
  /* background-color: ${props => props.$color ? lighten(props.$color, .93) : props.theme.colors.darkBg}; */
  background-color: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 8px;
  max-width: 35rem;
  padding: 1rem;
`;

const CardHeader = styled(BasicFlex)`

`;

const IconBox = styled(BasicFlex)`
  border-radius: 3px;
  background-color: ${props => lighten(props.$color, .85)};
  /* color: ${props => props.$color}; */
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: .7rem;
`;

const CardTitle = styled.div`
  font-size: 1.3rem;
  font-weight: 600;
  text-transform: uppercase;
  color: ${props => props.theme.colors.mildText};
  letter-spacing: .6px;
`;

const CardStat = styled.div`
  font-size: 2.2rem;
  font-weight: 700;
`;

const CardFooter = styled(BasicFlex)`
color: ${props => props.theme.colors.mildText};
`;

const StatCard = ({ title, stat, icon, description, color }) => {
  return (
    <Card dir="column" $color={color} gap="1rem">
      <CardHeader justify="flex-start" gap="1rem">
        <IconBox $color={color}>{icon}</IconBox>
        <CardTitle>{title}</CardTitle>
      </CardHeader>

      <CardStat>{stat}</CardStat>

      <CardFooter>
        <div>{description}</div>
      </CardFooter>
      
    </Card>
  )
}

const PaymentStats = ({ tableId }) => {
  const tableFinalQueryString = useTableStore((state) => state.tableFinalQueryString);
  let fq = tableFinalQueryString[tableId] || '';

  const { data: setting } = useQuery({
    queryKey: ['settings', 'general'],
    queryFn: () => getSettingByResource('general', 'general'),
  });

  let displayStats = setting?.data?.display_payment_totals || false;

  const { data: paymentStats } = useQuery({
    queryKey: ['paymentStats', fq],
    queryFn: () => getPaymentStats(fq),
    staleTime: 1000 * 60 * 30
  });

  console.log(paymentStats, "paymentStats");
  let { total_amount, total_count, total_applied_amount, total_available_amount, total_available_count } = paymentStats || {};

  // const cp = paymentStats?.snapshot || {};  // current period

  const theme = useTheme();

  if (!displayStats) return null;

  return (
    <Container justify="flex-start" gap="2rem">
       <StatCard title="Total Amount" stat={formatCurrency(total_amount || 0)} icon={<AttachMoneyRoundedIcon color="success" fontSize="small" />} description={`${total_count || 0} payments`} color={theme.palette.success.main} />
      <StatCard title="Total Unused" stat={formatCurrency(total_available_amount || 0)} icon={<WarningAmberRoundedIcon color="warning" fontSize="small" />} description={`${total_available_count || 0} payments`} color={theme.palette.warning.main} />
    </Container>
  )
};

export default PaymentStats;